"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getPostAuthNav3HeightMobile = exports.getPostAuthNav3Height = void 0;
// Desktop
var getPostAuthNav3Height = exports.getPostAuthNav3Height = function getPostAuthNav3Height(_ref) {
  var hasSecondaryData = _ref.hasSecondaryData,
    hasTertiaryData = _ref.hasTertiaryData,
    hasAnnouncementBar = _ref.hasAnnouncementBar,
    isMultiAnnouncementBar = _ref.isMultiAnnouncementBar;
  var utilityNavHeight = 76;
  var secondaryNavHeight = 40;
  var tertiaryNavHeight = 56;
  var singleAnnouncementBarHeight = 36; // remove when CE-3535 is rolled out
  var multiAnnouncementBarHeight = 56;
  var announcementBarHeight = isMultiAnnouncementBar ? multiAnnouncementBarHeight : singleAnnouncementBarHeight;
  var height = utilityNavHeight;
  if (hasAnnouncementBar) {
    height += announcementBarHeight;
  }
  if (hasSecondaryData) {
    height += secondaryNavHeight;
  }
  if (hasTertiaryData) {
    height += tertiaryNavHeight;
  }
  return height;
};

// Tablet & mobile
var getPostAuthNav3HeightMobile = exports.getPostAuthNav3HeightMobile = function getPostAuthNav3HeightMobile(_ref2) {
  var hasSecondaryData = _ref2.hasSecondaryData,
    hasTertiaryData = _ref2.hasTertiaryData;
  var utilityNavHeight = 56;
  var secondaryNavHeight = 40;
  var tertiaryNavHeight = 52;
  var height = utilityNavHeight;
  if (hasSecondaryData) {
    height += secondaryNavHeight;
  }
  if (hasTertiaryData) {
    height += tertiaryNavHeight;
  }
  return height;
};